import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import MoscowModalForm from "./MoscowModalForm";
import { MoscowSignUp, OpenModalMoscow } from "../../../../../Constants/Constants";

const MoscowModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn color="primary" onClick={toggle}>{OpenModalMoscow}</Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="justify-content-center border-0">{MoscowSignUp}</ModalHeader>
          <MoscowModalForm />
        </div>
      </Modal>
    </>
  );
};
export default MoscowModal